// Components/GuestTable.jsx
import React from "react";
import { guestColumns } from "./GuestData";
import DataTableHeader from "../../../../Common/DataTableHeader/DataTableHeader";
import DataTable from "../../../../Common/DataTable/DataTable";

const GuestTable = ({ data, loading, onEdit, onDelete }) => {
  const tableData = data.map((g, idx) => ({
    sno: idx + 1,
    name: g.name || "-",
    mobile_no: g.mobile_no || "-",
    email: g.email || "-",
    identity_type: g.identity_type || "-",
    identity_no: g.identity_no || "-",
    is_vip: g.is_vip ? <span className="badge bg-warning text-dark">VIP</span> : <span className="badge bg-secondary">No</span>,
    is_blacklisted: g.is_blacklisted ? <span className="badge bg-danger">Blacklisted</span> : <span className="badge bg-success">No</span>,
    actions: (
      <>
        <button className="btn btn-sm btn-outline-primary me-2" onClick={() => onEdit(g)}>
          <i className="bi bi-pencil-square"></i>
        </button>
        <button className="btn btn-sm btn-outline-danger" onClick={() => onDelete(g.id)}>
          <i className="bi bi-trash"></i>
        </button>
      </>
    ),
  }));

  return (
    <>
      <DataTableHeader />
      {loading ? (
        <div className="text-center py-4"><div className="spinner-border" /></div>
      ) : (
        <DataTable columns={guestColumns} data={tableData} />
      )}
    </>
  );
};

export default GuestTable;
